<div class="video-player-container">
  <div class="video-player-stage" [style.aspect-ratio]="videoAspectRatio">
    <div class="loading-overlay" *ngIf="isLoading && !hasError">
      <nz-spin [nzSize]="'large'"></nz-spin>
      <p class="loading-text">{{ 'LOADING' | translate }}</p>
    </div>

    <video
      #videoPlayer
      class="video-element"
      [class.video-element--hidden]="!showVideo || hasError"
      controls
      muted
      playsinline
      webkit-playsinline
      preload="auto"
      (loadedmetadata)="onVideoMetadataLoaded()"
      (loadeddata)="onVideoLoaded()"
      (error)="onVideoError()">
      <source #videoSource type="video/mp4">
      您的浏览器不支持视频播放。
    </video>

    <div class="error-message" *ngIf="hasError">
      <nz-icon nzType="close-circle" nzTheme="outline" class="error-icon"></nz-icon>
      <p class="error-text">{{ 'VIDEO_LOAD_ERROR' | translate }}</p>
      <p class="error-detail" *ngIf="attachmentId">
        {{ 'ATTACHMENT_ID' | translate }}: {{ attachmentId }}
      </p>
    </div>
  </div>
</div>
